import { createSelector } from "@reduxjs/toolkit";
import selectAssetsRaw from "./selectAssetsRaw";

export default createSelector(selectAssetsRaw, ({ uploadId }) => uploadId);
